import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { selectContentTasks } from '@redux/forms/reducers';
import { fetchForms } from '@redux/forms/actions';
import createColumns from './createFormColumns';
import ContentModal from './Modal';
import { FEATURE_TASK, whatTypeToTranslationKey } from '../../../../../../constants';
import './style.less';

const filterFunc = (value, comparator) => {
  return comparator(value.name) || comparator(value.description);
};

function SelectTaskModal({ defaultFilteredValue, onCancel, onOk }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, forms] = useSelector(selectContentTasks);
  const contentTypeTranslationKey = whatTypeToTranslationKey(FEATURE_TASK);
  const columns = useMemo(() => createColumns(t, defaultFilteredValue, contentTypeTranslationKey), [
    defaultFilteredValue,
    t,
    contentTypeTranslationKey,
  ]);
  useEffect(() => {
    dispatch(fetchForms());
  }, [dispatch]);

  return (
    <ContentModal
      columns={columns}
      data={forms}
      loading={loading}
      title={t('pathways:ProcedureRules.wizard.content.task')}
      filterFunc={filterFunc}
      onCancel={onCancel}
      onOk={onOk}
    />
  );
}

SelectTaskModal.propTypes = {
  onCancel: func.isRequired,
  onOk: func.isRequired,
};

export default SelectTaskModal;
